import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// T-0: Legacy-Migration — hybrid + leer + ungültig → dark
const resolveTheme = (stored) => {
  return stored === 'light' ? 'light' : 'dark';
};

const applyThemeToDOM = (themeValue) => {
  const html = document.documentElement;
  // Immer alle bekannten Theme-Klassen entfernen (inkl. legacy hybrid)
  html.classList.remove('dark', 'light', 'hybrid');
  html.classList.add(themeValue);
  // color-scheme: Browser-Controls, Scrollbars und native Formularfelder korrekt rendern
  html.style.colorScheme = themeValue;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');

  // Initialisierung: Legacy-Werte migrieren und Theme anwenden
  useEffect(() => {
    try {
      const stored = localStorage.getItem('clara360-theme');
      const resolved = resolveTheme(stored);

      // T-0: Legacy-Wert (hybrid, leer, ungültig) in localStorage korrigieren
      if (stored !== resolved) {
        localStorage.setItem('clara360-theme', resolved);
      }

      applyThemeToDOM(resolved);

      if (theme !== resolved) {
        setTheme(resolved);
      }
    } catch (error) {
      console.error('Error loading theme from localStorage:', error);
      applyThemeToDOM('dark');
      if (theme !== 'dark') {
        setTheme('dark');
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Theme-Änderungen persistieren und auf DOM anwenden
  useEffect(() => {
    // Skip initial render wenn kein gespeicherter Wert vorhanden
    if (theme === 'dark' && !localStorage.getItem('clara360-theme')) {
      return;
    }
    try {
      localStorage.setItem('clara360-theme', theme);
      applyThemeToDOM(theme);
    } catch (error) {
      console.error('Error saving theme to localStorage:', error);
    }
  }, [theme]);

  // T-2: 2-Wege-Toggle dark ↔ light (kein hybrid mehr)
  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
